export const APP_NAME = 'WAI-C'

export const FORMAT_TIME = 'YYYY-MM-DD HH:mm:ss'

export const FORMAT_DATE = 'YYYY-MM-DD'

export const SW_FILE_NAME = '/worker.js'

export const FULL_WIDTH = { width: '100%' }

export const LOGIN_QR_CODE_BASE_URL = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket='

export const LOADING_GIF = 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/101/weimengloading.gif'

export const CUSTOMER_SERVICE_QR_CODE =
  'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/wecom-temp-4755-283a11e8e9ea813340c5bf31b84b195e.png'

export enum SceneType {
  '抠图' = 1001,
  '商品主图' = 1002,
  '商详图' = 1003,
  '营销海报' = 1004,
  '海报一键生成' = 1015,
  '海报画相似' = 1016,
  '营销海报下载' = 1018,
  '商详重绘' = 1005,
  // 收费 - 抠图
  '智能抠图' = 1006,
  '图片分割抠图' = 1007,
  // 收费- 小工具换背景
  '智能抠图换背景' = 1008,
  '智能高清' = 1009,
  '智能超清' = 1011,
  '智能扩图' = 1010,
  '渲染背景' = 1012,
  '商详下载' = 1013,
  '商详预生成' = 1014,
  '批量生成背景'= 1024,
  '创意海报'=1025,
  '创意海报下载'=1028,
  '小红书种草文案' = 2001,
  '朋友圈营销文案' = 2002,
  '社群推广文案' = 2003,
  '公众号推广文案' = 2004,
  '商品标题主体解析' = 2005,
  '绘图提示词扩写' = 2006,
  '文案润色' = 2007,
  'ai帮我写' = 2008,
  '一键生成商详' = 2009,
  '新增或更换模块' = 2010,
  '商品海报切换目标语言' = 2018,
  '商详切换目标语言' = 2019,
  '图片翻译' = 1029,
  '试衣' = 1030,
  '换万物' = 1032,
  '商详行业背景封面' = 10031,
  '图生视频'=3001,
  '商详专业版' = 1050,
  'ai补图'=1056,
  '商详专业预生成'=1057,
  '试衣千问' = 1059,
  '商品套图标准' = 1060, 
  '商品套图专业版' = 1061,
  '商品套图专业结果' = 1062,
  '商品套图主图' = 1063,
  '商品套图卖点解析图' = 1064,
  '商品套图细节特写图' = 1065,
  '商品套图精修白底图' = 1066,
  '商品套图场景氛围图' = 1067,
  '商品介绍' = 1069,
  '手持商品' = 1070,
  '数字人' = 1071,
}

export enum SizeType {
  '手机海报' = 1,
  '横版海报' = 2,
  '公众号首图' = 3,
  '公众号次图' = 4,
  '小红书配图' = 5,
  '文章长图' = 6,
  '电商横版海报' = 7,
  '小程序启动页' = 8,
  '自定义' = 9,
}

export enum FloorType {
  '主图' = 3,
  '痛点' = 4,
  '卖点' = 5,
  '场景化' = 6,
  '背书' = 7,
  '使用说明'=8,
}

export const FloorMenu:any ={
  3:'主图楼层',
  4:'痛点楼层',
  5:'卖点楼层',
  6:'场景化楼层',
  7:'背书楼层',
  8:'使用说明楼层',
} 
export enum newSizeType{
  '手机海报'=1,
  '横版海报' = 2,
  '文章长图' = 3,
  '电商横版海报'=4,
  '小程序启动页'=5,
  '电商主图'=6,
  '自定义' = 7,
}


export enum MemberType {
  未开通,
  已开通,
  已过期,
}
export const continueType: any = [
  { id: SceneType.商品主图, name: 'AI商拍图' },
  { id: SceneType.营销海报, name: 'AI商品海报' },
  { id: SceneType.商详图, name: 'AI商详页' },
  { id: SceneType.智能抠图, name: '智能抠图' },
  { id: SceneType.智能抠图换背景, name: '智能换背景' },
  { id: SceneType.智能扩图, name: '智能扩图' },
  { id: SceneType.智能高清, name: '智能高清' },
  { id: SceneType.智能超清, name: '智能超清' },
]
export const sceneUrl: any = {
  1002: '/create/product-main-image',
  1003: '/create/product-details',
  1004: '/create/marketing-poster',
  1015: '/create/marketing-poster',
  1016: '/create/marketing-poster',
  1005: '/create/product-details',
  1012: '/create/product-details',
  1013: '/create/product-details',
  1014: '/create/product-details',
  1025: '/create/creativePoster',
  2001: '/create/marketing-writing',
  2002: '/create/marketing-writing',
  2003: '/create/marketing-writing',
  2004: '/create/marketing-writing',
  2007: '/create/marketing-writing',
  1006: '/tools/image-cutout',
  1010: '/tools/image-expand',
  1009: '/tools/image-quality',
  1011: '/tools/image-quality',
  1008: '/tools/background-replacement',
  1029: '/tools/image-translate',
  1030: '/create/tryClothes',
  1032: '/create/changeEverything',
  3001: '/create/image-to-video-old',
  1050: '/create/product-details',
  1057: '/create/product-details',
  1059: '/create/tryClothes',
  1060: '/create/product-main-image',
  1061: '/create/product-main-image',
  1062: '/create/product-main-image',
  1063: '/create/product-main-image',
  1064: '/create/product-main-image',
  1065: '/create/product-main-image',
  1066: '/create/product-main-image',
  1067: '/create/product-main-image',
  1069: '/create/image-to-video',
  1070: '/create/image-to-video',
  1071: '/create/image-to-video',
}
export const vistorQueryParams=['isVistorQuery']

export const languageList: any = [
    { id: 'zh', name: '中文 (简体)' },
    { id: 'zh-TW', name: '中文 (繁体)' }, 
    { id: 'en', name: '英语' }, 
    { id: 'ar', name: '阿拉伯语' }, 
    { id: 'de', name: '德语' },
    { id: 'es', name: '西班牙语' },
    { id: 'fr', name: '法语' },
    { id: 'it', name: '意大利语' },
    { id: 'ja', name: '日语' },
    { id: 'pt', name: '葡萄牙语' },
    { id: 'ru', name: '俄语' },
    { id: 'ko', name: '韩语' },
    { id: 'tr', name: '土耳其语' },
    { id: 'vi', name: '越南语' },
    { id: 'th', name: '泰语' },
    { id: 'ms', name: '马来语' },
];
export enum clothesType {
  '上装'='upper',
  '下装'='lower',
  '连体衣'='dress',
  '套装'='suit',
}
